import React, { Component } from 'react';
import { Button, Card, CardBody, CardHeader, Col, Container, Input, InputGroup, InputGroupAddon, InputGroupText, Row, NavLink } from 'reactstrap';

import CRNote from '../../Common/crNote'
import PageHead from '../../Common/pageHead'
import Menu from '../../Common/menu'

import Api from '../../../api'

class ForgetPw extends Component {
  constructor(props) {
    super(props)
    this.state = {
      email: '',
    }
  }

  forgot(e) {
    e.preventDefault()

    var api = new Api();
    api.check(this.state.email, (succ, user) => {
      if(succ) {
        api.forgot(this.state.email, (succ, msg) => {
          if(succ) {
            alert("An email with instructions on how to reset your password has been sent to "+this.state.email+". Check your spam or junk folder if you don’t see the email in your inbox.");
          } else {
            alert(msg);
          }
        });
      } else {
        alert("The email address you entered is incorrect Please try again.");
      }
    });
  }

  render() {
    return (
      <div className="app align-items-center mcg">
        <span className="frontbk" style={{zIndex:"0"}}  />

        <Container style={{zIndex:"1"}}>
          <PageHead/>
        </Container>

        <Container style={{zIndex:"2"}}>
          <Row className="justify-content-center">
              <Card className="mb-0">
                <Menu/>
                <CardHeader className="sihead">
                  <h1>Forget Password</h1>
                  <p className="text-center mb-0">
                    If you forgot your password please Fill in your email and click <b>Forgot Password</b>. 
                    Then check your email or spam folder for an email from us.
                  </p>
                </CardHeader>
                <CardBody className="login-form text-center logbox fgpw">
                  <InputGroup >
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="icon-envelope" />
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input type="email" placeholder="Email Address" autoComplete="emailaddress" onChange={(evt) => { this.setState({email: evt.target.value}); }} required/>
                  </InputGroup>
                  <div className="wraning-msg mb-4">
                    {/* Warning message for LoginID */}
                  </div>
                  
                  <Row>
                    <Col>
                      <Button color="primary" className="px-4 btn-brand" onClick={this.forgot.bind(this)}>Forget Password</Button>
                      <NavLink href="/login" className="mt-3">
                        <Button outline  className="px-4 btn-outline" color="primary">Back to Login</Button>
                      </NavLink>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
          </Row>
        </Container>

        <Container style={{zIndex:"2"}}>
          <CRNote/>
        </Container>
      </div>
    );
  }
}

export default ForgetPw;



// WEBPACK FOOTER //
// ./src/views/Pages/ForgetPw/ForgetPw.js